export default "__VITE_ASSET__VWZMMTCL__"